<title mat-dialog-title>{{ 'common.addToVault' | t }}</title>
<sn-form [formGroup]="form" [fields]="formFields" [model]="form">
  <mat-dialog-content>
    <div class="fs-row">
      <div class="fs-col-md-12">
        <p>
          {{ 'map.vaultDialog.uploadMessage' | t }}
        </p>
      </div>
      <div class="fs-col-md-12">
        <sn-slide-toggle formControlName="notifyByText"> {{ 'map.vaultDialog.notifyByText' | t }} </sn-slide-toggle>
      </div>
      <div class="fs-col-md-12">
        <sn-slide-toggle formControlName="notifyByEmail"> {{ 'map.vaultDialog.notifyByEmail' | t }} </sn-slide-toggle>
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button color="warn" (click)="cancel()">{{ 'common.cancel' | t }}</button>
    <button
      mat-button
      color="success"
      (click)="onSubmit()"
      type="submit"
      [mtBasicSpinner]="isLoading"
    >
      {{ 'common.done' | t }}
    </button>
  </mat-dialog-actions>
</sn-form>
